<template>
	<v-container id="background" bg fill-height grid-list-md text-xs-center fluid pa-0>
        <v-layout row wrap align-center>
          <v-flex >
          <div id="logo" class="display-4">
			<span class="font-weight-medium before-wings">a</span>
			
			<span class="wings display-4 font-weight-black"> 
				<span class="left-wing">3</span><span class="right-wing">3</span>
			</span> 
			<span class="font-weight-thin after-wings">mind</span>
		</div>
		<div id="subheading" class="subheading font-weight-regular">
         	a free mind, la libert&eacute; n'est pas un mot, c'est un choix
        </div>
        </v-flex>
		</v-layout>
	</v-container>
</template>

<script>
  export default {
    data: () => ({
		themes: [
			{ background: "#B5C7D3", primary:"#84898C", secondary: "#34558b", subheading:"#ffffff" },
			{ background: "#716A4D", primary:"#ff6f61", secondary: "#b5bab6", subheading:"#4a4843" },
			{ background: "#3d88a7", primary:"#6d5b97", secondary: "#c79c69", subheading:"#58575c" },
			{ background: "#404e5b", primary:"#83b14e", secondary: "#f0dcdd", subheading:"#94a6ce" },
			{ background: "#333", primary:"#666", secondary: "#fff", subheading:"#222" },
		],
		theme:0,
    }),
    mounted() {
		this.theme = Math.floor(Math.random() * 4);
		//this.theme=0;
		if(this.themes[this.theme]) {
			var t = this.themes[this.theme];
		
			document.querySelector("#background").style["background-color"] = t.background; 
			document.querySelector("#logo").style["background-color"] = t.secondary;
			document.querySelector("#logo").style["color"] = t.subheading;
			document.querySelector("#logo .wings").style["background-color"] = t.primary;
			document.querySelector("#logo .wings").style["border"] = '1px solid '+t.subheading;
			document.querySelector("#logo .wings .left-wing").style["color"] = t.secondary;
			document.querySelector("#subheading").style["background-color"] = t.subheading;
			document.querySelector("#subheading").style["color"] = t.secondary;
			document.querySelector("#logo .right-wing").style["color"] = t.background;
			
		}
		
		//this.theme = Math.floor(Math.random() * 4);
    }
  }
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Dancing+Script|Roboto&display=swap');

#background {
  /*background-color: #716A4D;*/
}
#logo {
  /*background-color: #b5bab6;*/
  width: 100%;
  text-align: center;
  padding:30px;
  /*color: #4a4843;*/
}
#subheading {
  /*background-color: #4a4843;
  color: #b5bab6;*/
}
#logo .wings {
   display: inline-block;
   border-radius: 50%;
   height:170px;
   width:170px;
   padding: 30px 20px 0 20px;
   /*background-color: #ff6f61;*/
   white-space: nowrap;
   text-align:center;
   font-family: "Dancing Script" !important;
   
}
#logo .left-wing {
  display: inline-block;
  -moz-transform:    scaleX(-1);
  -o-transform:      scaleX(-1); 
  -webkit-transform: scaleX(-1); 
  transform:         scaleX(-1); 

  filter: FlipH;
  letter-spacing: -5px;
  opacity: 0.3;
  /*color: #b5bab6;*/
}
#logo .right-wing {

}
#logo .after-wings,#logo .before-wings {
	margin:0 20px 0 20px;
}
</style>
